<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import PageLayout from 'dashboard/components-next/captain/PageLayout.vue';
import AgentKnowledgeBases from 'dashboard/components-next/captain/pageComponents/agent/AgentKnowledgeBases.vue';

const route = useRoute();
const assistantId = computed(() => Number(route.params.assistantId));
</script>

<template>
  <PageLayout :show-pagination-footer="false" :show-know-more="false">
    <template #body>
      <AgentKnowledgeBases :key="assistantId" :assistant-id="assistantId" />
    </template>
  </PageLayout>
</template>
